import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'
import Tags from '../tags/Tags'

export type ClientContractCardProps = {
  name: string
  startDate: string
  totalPackage: number
  isSelected: boolean
  onClick(): void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: theme.spacing(30),
      maxWidth: '100%',
      borderRadius: 4,
      border: `1px solid ${theme.palette.grey[300]}`
    },
    cardActionArea: {
      padding: theme.spacing(2),
      display: 'flex'
    },
    cardSelected: {
      background: theme.palette.grey[300],
      border: `1px solid ${theme.palette.grey[500]}`
    },
    cardLine: {
      background: theme.palette.secondary.main,
      width: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      borderRadius: 4,
      alignSelf: 'stretch'
    },
    cardContent: {
      width: '100%'
    },
    cardContentHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1)
    },
    cardContentBottom: {
      color: theme.palette.grey[800],
      marginRight: theme.spacing(2)
    }
  })
)

const ClientContractCard: React.FC<ClientContractCardProps> = (props) => {
  const {
    name = '-',
    startDate = '-',
    totalPackage = 0,
    isSelected = false,
    onClick
  } = props
  const classes = useStyles()
  return (
    <Card
      elevation={1}
      classes={{ root: classes.card }}
      className={isSelected ? classes.cardSelected : ''}
      onClick={(): void => {
        onClick()
      }}
    >
      <CardActionArea
        classes={{ root: classes.cardActionArea }}
        onClick={(): void => {
          onClick()
        }}
      >
        {isSelected ? <Box className={classes.cardLine} /> : ''}
        <Box className={classes.cardContent}>
          <Box className={classes.cardContentHeader}>
            <Typography variant="subtitle1" children={name} />
            <Tags
              customVariant="officeCleaning"
              label={
                totalPackage + (totalPackage > 1 ? ' Packages' : ' Package')
              }
              sizes="xs"
            />
          </Box>
          <Box>
            <Typography
              className={classes.cardContentBottom}
              variant="caption"
              children="Start Date:"
            />
            <Typography variant="caption" children={startDate} />
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default ClientContractCard
